import { CSSResultGroup, html, TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import componentStyles from './idb-indicators-header.css.lit';
import { OutlineElement } from '../../base/outline-element/outline-element';

/**
 * The IDB Toggle View component.
 * @element idb-indicators-header
 * @extends OutlineElement
 */
@customElement('idb-indicators-header')
export class IdbIndicatorsHeader extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  @property({ type: Array, attribute: 'sdgs' })
  sdgs = [];

  render(): TemplateResult {
    return html`
      <div class="container">
        <outline-container x-padding="" container-align="center">
          <section class="heading">
            <slot name="eyebrow"></slot>
            <slot name="title"></slot>
            <slot name="description"></slot>
          </section>
          <section class="sdgs">
            <slot name="related"></slot>
            <div class="sdg-list">${this.sdgs?.map((current)=> html`<img src="${current}"/>`)}</div>
          </section>
        </outline-container>
      </div>
    `;
  }
}
